module.exports = __webpack_public_path__ + "fonts/iconfont.427c088f.eot";